var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "map-wrapper" },
    [
      _c("div", {
        ref: "gmap",
        staticClass: "map-canvas",
        attrs: { id: "map-canvas" },
      }),
      _vm._v(" "),
      _c("map-info-overlay", {
        attrs: {
          show: _vm.showMarkerOverlay,
          location: _vm.selectedLocation,
          "map-type": _vm.options.MapType,
          "cta-button-title": _vm.options.CtaButtonTitle,
          "is-mobile": _vm.isMobile,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }